import styled from "styled-components";
import { colors } from "../../../../../styles/colors";

export const BodyItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;

  .card-body-item-text {
    .card-body-item-title {
      font-size: 12px;
      color: ${colors.darkBlue};
    }
    .card-body-item-value {
      font-size: 20px;
      color: ${colors.darkBlue};
    }
  }

  .card-body-item-type {
    margin-bottom: 5px;

    .type-icon {
      width: 18px;
      height: 18px;
      margin-left: 8px;
    }
  }

  &.has-separator {
    padding-bottom: 10px;
  }
`;
